import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../shared/libs/redux';
import {
	workshopModuleTagApi,
	workshopTagActions,
	workshopModuleTagSlice,
} from '../../../../entities/module/workshop-module-tag';
import { notificationError, notificationSuccess } from '../../../../components/Notifications/callNotifcation';

export const useEditWorkshopTag = () => {
	const dispatch = useAppDispatch();

	const name = useSelector(workshopModuleTagSlice.selectors.getEditTagName);
	const id = useSelector(workshopModuleTagSlice.selectors.getEditingTagId);

	const [editTag, requestData] = workshopModuleTagApi.useUpdateMutation();
	const { data: tagsResponse } = workshopModuleTagApi.useGetWorkshopTagsQuery({
		page: 1,
		limit: 127,
	});

	const onEditTag = async () => {
		try {
			if (id && name && tagsResponse?.moduleTags) {
				const workshopTags = tagsResponse.moduleTags.map((tag, index) => {
					if (tag.id === id) {
						return {
							...tag,
							name,
							sequenceNumber: index,
						};
					}
					return {
						...tag,
						sequenceNumber: index,
					};
				});

				await editTag({ workshopTags }).unwrap();

				dispatch(workshopTagActions.setEditTagName(''));
				dispatch(workshopTagActions.setEditingTagId(undefined));
				dispatch(workshopTagActions.setIsEditingTagModalActive(false));

				notificationSuccess('Тег изменен успешно');
			} else {
				notificationError('Не удалось получить данные для редактирования.');
			}
		} catch (e) {
			notificationError('Возникла ошибка при изменении тега...');
		}
	};

	return {
		onEditTag,
		requestData,
	};
};
